export default "__VITE_ASSET__D0bEPWFh__"